Ext.define('SA.VectorMapExportScaleBar', {
    singleton: true,

    viewBoxHeight: 12,
    viewBoxWidth: 70,

    attributes: {
        bar: {
            fill: 'transparent',
            stroke: '#333',
            strokeWidth: 1
        },

        distanceText: {
            dominantBaseline: 'middle',
            fill: '#333',
            textAnchor: 'middle',

            style: {
                fontFamily: 'Verdana, sans-serif',
                fontSize: '8px',
                fontVariantLigatures: 'no-common-ligatures',
                textShadow: '#fff 0 0 3px, #fff 0 0 3px, #fff 0 0 3px, #fff 0 0 3px, #fff 0 0 3px'
            }
        }
    },

    getSvg({extent, mapWidth, maxWidth, modelState}) {
        var feetPerMeter = 3.28084,
            feetPerMile = 5280,
            x = extent.getCenter().getX() + maxWidth * extent.getWidth() / mapWidth,
            y = extent.getCenter().getY(),
            maxDistance = extent.getCenter().metersTo(new SA.VectorMapCoordinate(x, y)),
            distance, unit, width, barWidth, left, top, right, bottom;

        if (SA.model.Country.get(modelState.country).isUSA()) {
            let maxDistanceInFeet = maxDistance * feetPerMeter;

            if (maxDistanceInFeet <= feetPerMile) {
                distance = nice(maxDistanceInFeet);
                unit = 'ft';
                width = distance * maxWidth / maxDistanceInFeet;
            }
            else {
                distance = nice(maxDistanceInFeet / feetPerMile);
                unit = 'mi';
                width = distance * feetPerMile * maxWidth / maxDistanceInFeet;
            }
        }
        else {
            if (maxDistance <= 1000) {
                distance = nice(maxDistance);
                unit = 'm';
                width = distance * maxWidth / maxDistance;
            }
            else {
                distance = nice(maxDistance / 1000);
                unit = 'km';
                width = distance * 1000 * maxWidth / maxDistance;
            }
        }

        barWidth = width * this.viewBoxWidth / maxWidth;

        left = Math.max((this.viewBoxWidth - barWidth) / 2, this.attributes.bar.strokeWidth / 2);
        top = 0;
        right = Math.min((this.viewBoxWidth + barWidth) / 2, this.viewBoxWidth - this.attributes.bar.strokeWidth / 2);
        bottom = this.viewBoxHeight - this.attributes.bar.strokeWidth / 2;

        return SA.Svg.create({
            type: 'svg',
            height: maxWidth * this.viewBoxHeight / this.viewBoxWidth,
            viewBox: `0 0 ${this.viewBoxWidth} ${this.viewBoxHeight}`,
            width: maxWidth,

            content: [
                {
                    type: 'polyline',
                    points: `${left},${top} ${left},${bottom} ${right},${bottom} ${right},${top}`,
                    ...this.attributes.bar
                }, {
                    type: 'text',
                    content: `${distance}\u00A0${unit}`,
                    x: this.viewBoxWidth / 2,
                    y: (this.viewBoxHeight - this.attributes.bar.strokeWidth) / 2,
                    ...this.attributes.distanceText
                }
            ]
        });

        function nice(n) {
            var base10Power = Math.trunc(Math.log10(n)),
                mostSignificantDigit = Math.trunc(n / 10 ** base10Power);

            return (mostSignificantDigit < 5 ? Math.min(3, mostSignificantDigit) : 5) * 10 ** base10Power;
        }
    }
});